module.exports = __webpack_public_path__ + "static/media/right-bridge.1de3c7b1.svg";